export enum PostReportReason {
  OTHER = 'OTHER',
  SPAM = 'SPAM',
  INAPPROPRIATE_BEHAVIOUR = 'INAPPROPRIATE_BEHAVIOUR',
  IN_DANGER = 'IN_DANGER',
  ILLEGAL = 'ILLEGAL',
}
